import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
// import _ from 'lodash';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GochiEventSettingTableHead from '../../components/molecules/GochiEventSettingTableHead';
import GochiEventSettingTableBody from '../../components/molecules/GochiEventSettingTableBody';
import ExPagination from '../../components/molecules/ExPagination';
import GochiEventSettingAdd from './GochiEventSettingAdd';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
import {
  getGochiEventSetting,
  deleteEventSetting,
  getGochiEventSettingDetail,
  updateStatusGochiEventSetting
} from '../../actions/GochiEventSetting';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      events: state.gochiEvent.list,
      totalCount: state.gochiEvent.count,
      offset: state.gochiEvent.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiEventSetting,
          deleteEventSetting,
          getGochiEventSettingDetail,
          updateStatusGochiEventSetting
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('detail', 'setDetail', null),

  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('showHide', 'setShowHide', 1),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    progress,
    searchKey,
    page,
    selectedPage,
    handleChangePage,
    events,
    totalCount,
    offset,
    openDelete,
    updateOpenDelete,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    openShowHide,
    updateOpenShowHide,
    showHide,
    setShowHide,
    detail,
    setDetail
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const getGochiEvent = async id => {
      await actions.getGochiEventSettingDetail(id).then(detailData => {
        checkSession(detailData);
        setDetail({ ...detailData.payload, gochiEventId: id });
      });
    };
    const editOpenAction = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiEvent(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEdit(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    const deleteOpenAction = id => {
      updateOpenDelete(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedMenu = await actions
        .deleteEventSetting(targetRowId)
        .then(data => checkSession(data));
      if (deletedMenu.type === 'DELETE_EVENT_SETTING_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleChangePage(null, selectedPage, rowsPerPage);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const showHideOpenAction = params => {
      updateOpenShowHide(true);
      if (params.status) {
        setShowHide(0);
      } else {
        setShowHide(1);
      }
      setTargetRowId(params.gochiEventId);
    };
    const cancelShowHideAction = () => updateOpenShowHide(false);
    const showHideAction = async () => {
      updateLoading(true);
      const showHidedMenuEvent = await actions
        .updateStatusGochiEventSetting({
          gochiEventId: targetRowId,
          status: showHide
        })
        .then(data => checkSession(data));
      if (
        showHidedMenuEvent.type === 'UPDATE_STATUS_GOCHI_EVENT_SETTING_SUCCESS'
      ) {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenShowHide(false);
      } else {
        updateLoading(false);
        updateOpenShowHide(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiEventSettingTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              // roles={roles}
            />
            <GochiEventSettingTableBody
              events={events}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              editOpenAction={editOpenAction}
              deleteOpenAction={deleteOpenAction}
              showHideOpenAction={showHideOpenAction}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={events}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal open={openEdit}>
          <GochiEventSettingAdd
            openAddConfirm={openEditConfirm}
            updateOpenAdd={updateOpenEdit}
            updateOpenAddConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
          />
        </Modal>
        <ConfirmDialog
          openConfirm={openShowHide}
          cancelAction={cancelShowHideAction}
          updateOpenConfirm={updateOpenShowHide}
          okAction={showHideAction}
          targetRowId={targetRowId}
          message="イベントステータスを変更します。よろしいでしょうか？"
        />
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="メニュー"
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
